import { generateLegends } from '~/utils/chart/customLegends/general'

const capacityClasses = [
  'flex',
  'gap-4',
  'mx-4',
  'flex-wrap',
  'justify-center',
  'sm:mx-auto',
  'lg:flex-nowrap',
]

export const generateCapacityLegends = {
  id: 'htmlLegend',
  afterUpdate(chart, _, options) {
    generateLegends(chart, options, 'capacity', capacityClasses)
  },
}
